import { Collapse } from '@repo/go-ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import type { TTrajectoryExcludeReason } from '../../types/graph-trajectory';

import styles from './trajectory-chart-warnings.module.scss';

const WARNINGS_PANEL_KEY = 'warnings';

export type TrajectoryChartWarningItem = {
  title: string;
  reason: TTrajectoryExcludeReason;
};

type Props = {
  warnings: TrajectoryChartWarningItem[];
  className?: string;
  /** Start collapsed (default true). */
  defaultCollapsed?: boolean;
};

export function TrajectoryChartWarnings({ warnings, className, defaultCollapsed = true }: Props) {
  const { t } = useTranslation();

  if (warnings.length === 0) {
    return null;
  }

  return (
    <div className={clsx(styles.warnings, className)} role="status">
      <Collapse defaultValue={defaultCollapsed ? [] : [WARNINGS_PANEL_KEY]}>
        <Collapse.Panel
          panelKey={WARNINGS_PANEL_KEY}
          iconPlacement="end"
          header={`${t('Graph.warnings.title')} (${warnings.length})`}
        >
          <ul className={styles.warningsList}>
            {warnings.map((warning) => (
              <li key={`${warning.title}-${warning.reason}`}>
                {warning.title}: {t(`Graph.warnings.${warning.reason}`)}
              </li>
            ))}
          </ul>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}
